export default "/WebApp/dist/assets/svg/newplus.svg";